import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import CheckboxField from './field'
import BoxField from "./boxfield";
import {isHTML} from "../../../../utilities/function/common";

function Checkbox (props) {
  const { data, className, name } = props
  const renderField = (item,index) =>{
    const {key, value,price,description} = item
    let fieldName = `${name}-${key}`
    if(name && name.indexOf("[") !== -1 && name.indexOf("]") !== -1 ){
      fieldName = `${name}[option-${key}]`
    }
    if(price && price==="0.00"){
      return (<Field key={index} item={item} name={fieldName} component={CheckboxField} locked={true}  value={value}  />)
    }
    if(description && isHTML(description)){
      return (<Field key={index} item={item} name={fieldName} component={BoxField} value={value} />)
    }
    return (<Field key={index} item={item} name={fieldName} component={CheckboxField} value={value}  />)
  }
  const renderList = () => {
    if (data && data.length > 0) {
      return data.map((item, index) => {
        return (renderField(item, index))
      })
    }
  }


  return (
    <div className={`of-checkbox${className ? ' ' + className : ''}`}>
      <div className='of-checkbox__list'>
        {renderList()}
      </div>
    </div>
  )
}

Checkbox.propTypes = {
  data: PropTypes.any,
  name: PropTypes.string,
  className: PropTypes.string
}

export default Checkbox
